jQuery(function ($) {
	/**
	 * Tab Navigation
	 */
	$('.wkmpa-tab-link').on('click', function (e) {
		e.preventDefault();
		$('.wkmpa-tab-link').removeClass('active');
		$(this).addClass('active');
		$('.wkmpa-tab-content').removeClass('active');
		$($(this).attr('href')).addClass('active');
	});

	/**
	 * Sponsored Product Selection AJAX
	 */
	$('.wkmpa-sponsored-selection-form').on('submit', function (e) {
		e.preventDefault();
		var $form = $(this);
		var $submit = $form.find('button[type="submit"]');
		var initialText = $submit.text();

		$submit.prop('disabled', true).text('Activating...');

		$.ajax({
			url: wkmpa_dashboard_obj.ajax_url,
			type: 'POST',
			data: $form.serialize(),
			success: function (response) {
				if (response.success) {
					alert(response.data.message);
					location.reload();
				} else {
					alert(response.data);
					$submit.prop('disabled', false).text(initialText);
				}
			},
			error: function () {
				alert('An error occurred. Please try again.');
				$submit.prop('disabled', false).text(initialText);
			}
		});
	});

	/**
	 * Show Banner Submission Form when clicking "Request Placement"
	 */
	$(document).on('click', '.wkmpa-request-banner', function (e) {
		e.preventDefault();
		var productId = $(this).data('id');

		// Map the selected product to the radio button in the form
		if (productId) {
			$('#slot-' + productId).prop('checked', true).trigger('change');
		}

		$('#wkmpa-dashboard-banner-form-wrap').slideDown();

		// Scroll to form
		$('html, body').animate({
			scrollTop: $("#wkmpa-dashboard-banner-form-wrap").offset().top - 100
		}, 600);
	});

	/**
	 * Premium Plan Purchase (Buy Now)
	 */
	$(document).on('click', '.wkmpa-buy-now', function (e) {
		e.preventDefault();
		var $btn = $(this);
		var productId = $btn.data('id');
		var bannerId = $btn.data('banner-id');
		var initialText = $btn.text();

		$btn.prop('disabled', true).text('Processing...');

		$.ajax({
			url: wkmpa_dashboard_obj.ajax_url,
			type: 'POST',
			data: {
				action: 'wkmpa_add_plan_to_cart',
				product_id: productId,
				wkmpa_banner_id: bannerId,
				nonce: wkmpa_dashboard_obj.nonce
			},
			success: function (response) {
				if (response.success) {
					// Redirect to checkout
					window.location.href = response.data.redirect_url;
				} else {
					alert(response.data);
					$btn.prop('disabled', false).text(initialText);
				}
			},
			error: function () {
				alert('An error occurred. Please try again.');
				$btn.prop('disabled', false).text(initialText);
			}
		});
	});

	/**
	 * Initialize Select2 if available (common in WC admin/seller dashboards)
	 */
	if ($.isFunction($.fn.select2)) {
		$('.wkmpa-select2').select2({
			placeholder: "Select products...",
			allowClear: true
		});
	}

	if (typeof wkmpaBannerSubmit === 'undefined') return;

	function initBannerForm() {
		var prodSel = document.getElementById('wkmpa-banner-products');
		if ($.isFunction($.fn.select2) && prodSel) {
			$(prodSel).select2({
				placeholder: "Search for products...",
				allowClear: true
			});
		}
	}

	initBannerForm();

	// Update hint when slot changes.
	$(document).on('change', 'input[name="banner_slot_id"]', function () {
		var max = $(this).data('max');
		var hint = document.querySelector('.wkmpa-max-hint-v3');
		if (max && hint) {
			hint.textContent = 'You can select up to ' + max + ' product(s).';
		}
	});

	// Handle Edit Banner Click
	$(document).on('click', '.wkmpa-edit-banner', function (e) {
		e.preventDefault();
		var $btn = $(this);
		var bannerId = $btn.data('id');
		var slotId = $btn.data('slot');
		var products = $btn.data('products');

		// Populate Slot
		var $slotRadio = $('#slot-' + slotId);
		if ($slotRadio.length) {
			$slotRadio.prop('checked', true).trigger('change');
		}

		// Populate Products
		var $prodSel = $('#wkmpa-banner-products');
		if ($prodSel.length) {
			$prodSel.val(products).trigger('change');
		}

		// Add/Update hidden input for banner_id
		var $form = $('#wkmpa-banner-form');
		if ($('#wkmpa-edit-banner-id').length === 0) {
			$form.append('<input type="hidden" name="banner_id" id="wkmpa-edit-banner-id" value="' + bannerId + '">');
		} else {
			$('#wkmpa-edit-banner-id').val(bannerId);
		}

		// Change button text
		$form.find('button[type="submit"] span').text('Update Proposal');

		// Show form
		$('#wkmpa-dashboard-banner-form-wrap').slideDown();

		// Scroll to form
		$('html, body').animate({
			scrollTop: $("#wkmpa-dashboard-banner-form-wrap").offset().top - 100
		}, 600);
	});

	$(document).on('submit', '#wkmpa-banner-form', function (e) {
		e.preventDefault();
		var form = this;
		var msgEl = document.getElementById('wkmpa-banner-msg');
		var prodSel = document.getElementById('wkmpa-banner-products');

		var selectedRadio = form.querySelector('input[name="banner_slot_id"]:checked');
		var slotId = selectedRadio ? selectedRadio.value : '';
		var productIds = [];
		if (prodSel) {
			Array.from(prodSel.selectedOptions).forEach(function (o) { productIds.push(o.value); });
		}

		if (!slotId) {
			if (msgEl) msgEl.textContent = 'Please select a banner slot.';
			return;
		}

		if (!productIds.length) {
			if (msgEl) msgEl.textContent = 'Please select at least one product.';
			return;
		}

		var submitBtn = form.querySelector('[type="submit"]');
		if (submitBtn) submitBtn.disabled = true;
		if (msgEl) msgEl.textContent = wkmpaBannerSubmit.labels.submitting;

		var bannerId = form.querySelector('input[name="banner_id"]') ? form.querySelector('input[name="banner_id"]').value : '';

		$.post(wkmpaBannerSubmit.ajaxUrl, {
			action: wkmpaBannerSubmit.action,
			nonce: wkmpaBannerSubmit.nonce,
			banner_id: bannerId,
			banner_slot_id: slotId,
			product_ids: productIds
		}, function (res) {
			if (submitBtn) submitBtn.disabled = false;
			if (res.success) {
				// Re-find msgEl in the new HTML or use the old one if not replaced
				var newMsgEl = document.getElementById('wkmpa-banner-msg');
				if (newMsgEl) {
					newMsgEl.textContent = res.data.message || wkmpaBannerSubmit.labels.success;
					newMsgEl.style.color = '#155724';
					newMsgEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}

				// Update Banners list if HTML is provided
				setTimeout(function () {
					if (res.data.html) {
						$('#banners').html(res.data.html);
						if (newMsgEl) newMsgEl.innerHTML = '';
						
						// Reset form and hidden fields
						form.reset();
						$('#wkmpa-edit-banner-id').remove();
						$(form).find('button[type="submit"] span').text('Submit Proposal');
						$(prodSel).val(null).trigger('change');

						initBannerForm(); // Re-initialize Select2 for the new form
					}
				}, 500);
			} else {
				var errorMsg = (typeof res.data === 'string' ? res.data : (res.data.message || wkmpaBannerSubmit.labels.error));
				if (msgEl) {
					msgEl.textContent = errorMsg;
					msgEl.style.color = '#e44a05';
				}
			}
		}).fail(function () {
			if (submitBtn) submitBtn.disabled = false;
			if (msgEl) { msgEl.textContent = wkmpaBannerSubmit.labels.error; msgEl.style.color = '#e44a05'; }
		});
	});

	// Handle Date Saving
	$(document).on('submit', '#wkmpa-holiday-form', function (e) {
		e.preventDefault();
		var $btn = $(this).find('.wkmpa-holiday-save');
		var $msg = $('#wkmpa-holiday-msg');
		var data = {
			action: 'wkmpa_toggle_holiday',
			nonce: $btn.data('nonce'),
			action_type: 'save',
			start_date: $(this).find('[name="start_date"]').val(),
			end_date: $(this).find('[name="end_date"]').val()
		};

		$btn.prop('disabled', true).text('Saving…');
		$msg.text('').removeClass('success error').show();

		$.post(wkmpaBannerSubmit.ajaxUrl, data, function (res) {
			if (res.success) {
				$msg.text(res.data).addClass('success');
				setTimeout(function () { $msg.fadeOut(); }, 3000);
			} else {
				$msg.text(res.data).addClass('error');
			}
			$btn.prop('disabled', false).text('Save Holiday Settings');
		});
	});

	// Handle Toggle Activation
	$(document).on('change', '#wkmpa-holiday-toggle', function () {
		var $checkbox = $(this);
		var $label = $checkbox.closest('.wkmpa-toggle-wrapper').find('.wkmpa-toggle-label');
		var isChecked = $checkbox.is(':checked');
		var $msg = $('#wkmpa-holiday-msg');

		$checkbox.prop('disabled', true);
		$msg.text('Processing…').removeClass('success error').show();

		$.post(wkmpaBannerSubmit.ajaxUrl, {
			action: 'wkmpa_toggle_holiday',
			nonce: $checkbox.data('nonce'),
			action_type: 'toggle',
			enable: isChecked ? 1 : 0
		}, function (res) {
			if (res.success) {
				$label.text(isChecked ? 'Active' : 'Inactive');
				$msg.text(res.data).addClass('success');
				setTimeout(function () { location.reload(); }, 1000);
			} else {
				$checkbox.prop('checked', !isChecked); // Revert
				$msg.text(res.data).addClass('error');
			}
			$checkbox.prop('disabled', false);
		});
	});
});
